export default __webpack_public_path__ + "static/img/login-logo.f49db65.png";